/**
 * Fixed path words on Tracker AI v1 routes.
 * shortcut: a new static segment must be added here, or a one-param call will omit that param from the body.
 */
const STATIC_SEGMENTS = new Set([
  'projects',
  'ensure',
  'activity-range',
  'insight',
  'prompts',
  'list',
  'topics',
  'visibility-summary',
  'visibility-trend',
  'share-of-voice-trend',
  'competitor-intelligence',
  'source-insights',
  'summary',
  'domains',
  'types',
  'trend',
  'brands',
  'competitor-gap',
  'filter-options',
  'brand-aliases',
  'competitors',
  'from-extracted',
  'insights',
  'executions',
  'history',
  'models',
  'public',
  'run',
  'runs',
  'batch',
  'suggest-prompts',
  'overview',
  'brand-aggregation',
  'execution-status',
  'reextract-brands',
  'get',
]);

let trackerDomainSlug = '';

export function getTrackerDomainSlug(): string {
  if (trackerDomainSlug) return trackerDomainSlug;
  return trackerDomainSlugFromPath();
}

function trackerDomainSlugFromPath(): string {
  if (typeof window === 'undefined') return '';
  const parts = window.location.pathname.split('/').filter(Boolean);
  const sectionIndex = parts.indexOf('tracker-ai');
  if (sectionIndex < 0) return '';
  return parts[sectionIndex + 2]?.trim() ?? '';
}

/** Returns true when the slug used on the next request changed. */
export function setTrackerDomainSlug(slug: string | null | undefined): boolean {
  const previous = getTrackerDomainSlug();
  trackerDomainSlug = slug?.trim() ?? '';
  return previous !== getTrackerDomainSlug();
}

/** The only dynamic segment, when the URL has exactly one. */
export function singleAddressParam(
  url: string,
): { key: 'id' | 'topicId' | 'batchId'; value: string } | null {
  const path = url.split('?')[0]?.split('#')[0] ?? '';
  const parts = path.split('/').filter(Boolean);
  const dynamicIndexes = parts.flatMap((part, index) =>
    STATIC_SEGMENTS.has(part) ? [] : [index],
  );
  if (dynamicIndexes.length !== 1) return null;
  const index = dynamicIndexes[0];
  const value = decodeURIComponent(parts[index] ?? '').trim();
  if (!value) return null;
  const parent = parts[index - 1];
  const key =
    parent === 'topics' ? 'topicId' : parent === 'runs' ? 'batchId' : 'id';
  return { key, value };
}
